import React, { useState } from "react";
import styles from "./StudentMovement.module.css";
import HeadingAndIcon from "../../components/HeadingAndIcon/HeadingAndIcon";
import HeadingAndDropDown from "../../components/HeadingAndDropDown/HeadingAndDropDown";
import SaveAndCancel from "../../components/SaveAndCancel/SaveAndCancel";
import ToClose from "../../components/ToClose/ToClose";
import { FaPlusCircle } from "react-icons/fa";
import { useDispatch } from "react-redux";
import { closeModal } from "../../redux/slices/modalSlice";

const StudentMovement = () => {
  const dispatch = useDispatch();

  const [student, setStudent] = useState("");
  const [currentProgram, setCurrentProgram] = useState("");
  const [ruleType, setRuleType] = useState("");
  const [movementDate, setMovementDate] = useState("");
  const [moveOption1, setMoveOption1] = useState(false);
  const [moveOption2, setMoveOption2] = useState(false);

  const handleCancel = () => {
    setStudent("");
    setCurrentProgram("");
    setRuleType("");
    setMovementDate("");
    setMoveOption1(false);
    setMoveOption2(false);
  };

  const handleSubmit = () => {
    if (!student || !currentProgram || !ruleType || !movementDate) {
      alert("Please fill all mandatory (*) fields.");
      return;
    }

    const payload = {
      student,
      currentProgram,
      ruleType,
      movementDate,
      moveOption1,
      moveOption2,
    };
    console.log("✔ Submitted Student Movement:", payload);
    dispatch(closeModal());
  };

  return (
    <div className={styles.cardContainer}>
      <div className={styles.cardHeader}>
        <HeadingAndIcon icon={<FaPlusCircle />} heading="Add New Rule" />
        <ToClose onClose={() => dispatch(closeModal())} />
      </div>

      <div className={styles.cardBody}>
        <HeadingAndDropDown
          label="Select Student"
          name="selectStudent"
          value={student}
          onChange={(e) => setStudent(e.target.value)}
          required
          placeholder="Select Student"
          options={[
            { label: "Student A", value: "studentA" },
            { label: "Student B", value: "studentB" },
          ]}
        />

        <HeadingAndDropDown
          label="When leaving Current Program"
          name="currentProgram"
          value={currentProgram}
          onChange={(e) => setCurrentProgram(e.target.value)}
          required
          placeholder="Select program"
          options={[
            { label: "Program A", value: "programA" },
            { label: "Program B", value: "programB" },
          ]}
        />

        <label className={styles.studentWillLabel}>A Student Will :</label>
        <div className={styles.checkboxGroup}>
          <label
            className={`${styles.checkLabel} ${
              moveOption1 ? styles.active : ""
            }`}
          >
            <input
              type="checkbox"
              checked={moveOption1}
              onChange={(e) => setMoveOption1(e.target.checked)}
            />
            Move to Next Program
          </label>

          <label
            className={`${styles.checkLabel} ${
              moveOption2 ? styles.active : ""
            }`}
          >
            <input
              type="checkbox"
              checked={moveOption2}
              onChange={(e) => setMoveOption2(e.target.checked)}
            />
            Leave the Program
          </label>
        </div>

        <HeadingAndDropDown
          label="Movement Rule"
          name="ruleType"
          value={ruleType}
          onChange={(e) => setRuleType(e.target.value)}
          required
          placeholder="Select movement rule"
          options={[
            { label: "Based on Age", value: "age" },
            { label: "Based on Date", value: "date" },
          ]}
        />

        <div className={styles.inputBlock}>
          <label className={styles.inputLabel}>
            Date <span className={styles.required}>*</span>
          </label>
          <input
            type="date"
            value={movementDate}
            onChange={(e) => setMovementDate(e.target.value)}
            placeholder="Select Date"
            className={styles.inputField}
            required
          />
        </div>

        <div className={styles.footerActions}>
          <SaveAndCancel
            onSave={handleSubmit}
            onCancel={handleCancel}
            saveLabel="Submit"
          />
        </div>
      </div>
    </div>
  );
};

export default StudentMovement;
